var _circle, _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 236,
    viewBox: "0 0 224 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.818,
    cy: 122.827,
    r: 82.138,
    fill: "#4ACCA9",
    stroke: "#B4E9DA",
    strokeWidth: 17.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.324 107.787L143.204 90.9966L103.257 130.175L80.4306 107.787L63.3105 124.578L103.257 163.757L160.324 107.787Z",
    fill: "#E1F6F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6465,
    width: 27.3865,
    height: 27.3865,
    transform: "rotate(45 21.6465 0)",
    fill: "#B4E9DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9102,
    y: 38.7981,
    width: 18.2576,
    height: 18.2576,
    transform: "rotate(45 12.9102 38.7981)",
    fill: "#B4E9DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 204.225,
    y: 196.271,
    width: 27.3865,
    height: 27.3865,
    transform: "rotate(45 204.225 196.271)",
    fill: "#B4E9DA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b60985d7a90db264c7195f3d1c8a9a3a.svg";
export { ForwardRef as ReactComponent };